module.exports = __webpack_public_path__ + "hyperion-v2-static/img/SamplePulseDelta.77160a3c.png";